import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    talklogosFiltrarCanais(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("chatlogos/access/filtrarCanais", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    talklogosEfetuarLigacao(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("chatlogos/access/efetuarLigacao", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    talklogosEnviarMensagemPrivada(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("chatlogos/access/enviarMensagemPrivada", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};